// ============================================================
// api/careChargeRoles.js  (role-model expansion Push 1, 2026-07-13)
// Admin-portal client for the CareCharge module-role endpoints.
// Clone of api/carePeopleRoles.js against the finance overlay (F4;
// vocabulary widened to finance | finance_manager). No tier — finance
// has a single access level (locked F1); finance_manager differs by
// module-CONFIG write, not scope.
//
// Backend reference:
//   admin-carecharge-role-get.js    (GET    -> { coreRole, coreRoleApplicable, current, history })
//   admin-carecharge-role-grant.js  (POST   { careChargeRole })
//   admin-carecharge-role-revoke.js (DELETE -> { revoked, careChargeRole? })
//
// One path, three methods:
//   /api/mgmt/admin/users/{clientUserId}/carecharge-role
// ============================================================

import { apiGet, apiPost, apiDelete } from './client';

export async function getCareChargeRole(clientUserId) {
  return apiGet(`/mgmt/admin/users/${clientUserId}/carecharge-role`);
}

export async function grantCareChargeRole(clientUserId, { careChargeRole }) {
  return apiPost(`/mgmt/admin/users/${clientUserId}/carecharge-role`, { careChargeRole });
}

export async function revokeCareChargeRole(clientUserId) {
  return apiDelete(`/mgmt/admin/users/${clientUserId}/carecharge-role`);
}
